var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-select",class:{ 'language-select--absolute': _vm.positionAbsolute }},[_c('v-select',{ref:"languageSelect",attrs:{"value":_vm.selectedLanguage,"return-object":"","items":_vm.langs,"item-text":"locale","item-value":"value","hide-details":true,"dense":"","outlined":"","rounded":"","append-icon":"icon-arrow-down","full-width":"","menu-props":{
      contentClass: 'language-select-menu',
      offsetY: true
    }},on:{"input":_vm.setLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }